import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useConsultantBonusHistory = (id, page = 1, term = null, operation = null) => useQuery({ queryKey: ['consultant-bonus-history', id, page, term, operation], queryFn: async () => {
    const callback = await API.get(`/consultants/${id}/bonus?page=${page}${term ? `&term=${term}` : ''}${operation ? `&operation=${operation}` : ''}`)
    return callback?.data
}})

export default useConsultantBonusHistory